import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { api } from "../../../services/Main/Api"
import { getCondoId } from "../../../services/Main/AuthStorage"
import CircularProgress from "@mui/material/CircularProgress"
import AnimationGlobal from "../../../components/Shared/animations/AnimationGlobal"
import successAnimation from "../../../assets/animations/success.json"
import { useSnackbar } from "notistack"
import ComodoAutocomplete from "../../../components/Autocomplete/ComodoAutocomplete"
import Masks from "../../../components/Shared/Masks"

function InspectionForm({ closeForm, onCreated }) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const [renterChoices, setRenterChoices] = useState([])
  const [renter, setRenter] = useState(null)
  const [openDialog, setOpenDialog] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [activeBackdrop, setActiveBackdrop] = useState(false)
  const [comodosSelecionados, setComodosSelecionados] = useState([])

  const [formData, setFormData] = useState({
    name: "",
    cpf_or_cnpj: "",
    phone: "",
    email: "",
    unit: null,
    rent_contract: null,
    type_inspection: "initial",
  })

  function updateField(field, value) {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  function getRenters() {
    const condo_id = getCondoId()
    api
      .get(`/rent-contract/unit/?condo_id=${condo_id}`)
      .then((response) => {
        setRenterChoices(response.data.results || response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    getRenters()
  }, [])

  function handleRenterSelect(event, newValue) {
    if (!newValue) {
      setRenter(null)
      return
    }
    const selected = renterChoices.find((item) => item.id === newValue.id)
    setRenter(selected)
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        name: selected.name || "",
        cpf_or_cnpj: selected.cpf || "",
        phone: selected.phone || "",
        email: selected.email || "",
        unit: selected.id,
        rent_contract: selected.rent_contract_id || null,
      }))
    }
  }

  function handleSaveInspection() {
    if (!formData.name) {
      enqueueSnackbar("Preencha o nome.", { variant: "warning" })
      return
    }
    if (comodosSelecionados.length === 0) {
      enqueueSnackbar("Adicione pelo menos um cômodo.", { variant: "warning" })
      return
    }

    setIsSaving(true)
    setOpenDialog(false)
    setActiveBackdrop(true)

    const payload = {
      name: formData.name,
      cpf_or_cnpj: formData.cpf_or_cnpj,
      phone: formData.phone,
      email: formData.email,
      unit: formData.unit,
      rent_contract: formData.rent_contract,
      type_inspection: formData.type_inspection,
      characteristics: comodosSelecionados,
    }

    api
      .post("/property-inspection/", payload)
      .then((response) => {
        const result = response.data
        setTimeout(() => {
          setIsSuccess(true)
        }, 1500)

        setTimeout(() => {
          setActiveBackdrop(false)
          closeForm()
          if (onCreated) {
            onCreated(result.id)
          } else {
            navigate(`/vistoria/${result.id}`)
          }
        }, 3000)
      })
      .catch((error) => {
        setIsSaving(false)
        setActiveBackdrop(false)
        setOpenDialog(true)
        const errData = error?.response?.data
        if (errData?.message) {
          enqueueSnackbar(errData.message, { variant: "error" })
        } else if (errData?.[0]) {
          enqueueSnackbar(errData[0], { variant: "error" })
        } else {
          enqueueSnackbar("Erro ao criar vistoria.", { variant: "error" })
        }
        console.log("error", error)
      })
  }

  const handleComodosChange = (novosComodos) => {
    setComodosSelecionados(novosComodos)
  }

  const canSave = formData.name && comodosSelecionados.length > 0

  return (
    <Grid item xs={12}>
      <Dialog
        fullWidth
        maxWidth="md"
        open={openDialog}
        scroll="body"
        onClose={() => closeForm()}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mr: "1rem",
          }}
        >
          <DialogTitle>Nova Vistoria</DialogTitle>
        </Box>

        <Divider />

        <DialogContent>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="inspection-type-label">Tipo</InputLabel>
                <Select
                  labelId="inspection-type-label"
                  value={formData.type_inspection}
                  label="Tipo"
                  onChange={(e) => updateField("type_inspection", e.target.value)}
                >
                  <MenuItem value="initial">Entrada</MenuItem>
                  <MenuItem value="exit">Saída</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                onChange={handleRenterSelect}
                options={renterChoices.map((item) => ({
                  id: item.id,
                  label: item.name,
                }))}
                renderInput={(params) => (
                  <TextField {...params} label="Locatário (opcional)" />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                label="Nome *"
                fullWidth
                size="small"
                value={formData.name}
                onChange={(e) => updateField("name", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="CPF/CNPJ"
                fullWidth
                size="small"
                value={Masks.cpfOrCnpj(formData.cpf_or_cnpj)}
                onChange={(e) => updateField("cpf_or_cnpj", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Telefone"
                fullWidth
                size="small"
                value={formData.phone}
                onChange={(e) => updateField("phone", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="E-mail"
                fullWidth
                size="small"
                value={formData.email}
                onChange={(e) => updateField("email", e.target.value)}
              />
            </Grid>

            {renter?.full_address && (
              <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary">
                  <strong>Endereço:</strong> {renter.full_address}
                </Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogTitle sx={{ display: "flex", justifyContent: "center" }}>
          Características do imóvel
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={1} mt={0}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <ComodoAutocomplete onChange={handleComodosChange} />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <Divider />

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "2rem 1rem",
          }}
        >
          <Button variant="text" color="secondary" onClick={() => closeForm()}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            disabled={!canSave || isSaving}
            onClick={handleSaveInspection}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={activeBackdrop}
      >
        {!isSuccess ? (
          <Box>
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <AnimationGlobal
            text="Vistoria criada com sucesso!"
            size="200px"
            animation={successAnimation}
            fontStyles={{ mb: "1rem" }}
            fontSize="20px"
            color="#FFFFFF"
          />
        )}
      </Backdrop>
    </Grid>
  )
}

export default InspectionForm
